/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NotFound/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import LoadingBar from 'DesignSystem/LoadingBar/index'
import React from 'react'
import SubTitle from 'DesignSystem/SubTitle/index'
import Title from 'DesignSystem/Title/index'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function NotFound({
  children,
  viewPath = "/App/NotFound"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="NotFound.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Title
  viewPath={`${viewPath}/Title`}
 text="Sorry."
/>
<SubTitle
  viewPath={`${viewPath}/SubTitle`}
 marginTop={12}
 text="We couldn't find what you're looking for."
/>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 marginTop={dtSpaceXs}
 goTo="/"
 target="_self"
 text="Go to the main page"
/>
<LoadingBar
  viewPath={`${viewPath}/LoadingBar`}
/>
</div>
{children}
</React.Fragment>)
}